import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

export default function DiagnosisBanner() {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);

  const goToDiagnosis = () => {
    navigate('/');
    setTimeout(() => {
      const el = document.getElementById('diagnosis');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 300);
  };

  const scrollToContact = () => {
    navigate('/');
    setTimeout(() => {
      const contactSection = document.getElementById('contact-form');
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: 'smooth' });
      }
    }, 300);
  };

  return (
    <>
      <section className="py-16 bg-gradient-to-r from-[#f8f6f3] via-white to-[#f8f6f3]">
        <div className="max-w-6xl mx-auto px-6">
          <div 
            className="relative bg-gradient-to-br from-[#1a2332] via-[#243447] to-[#1a2332] rounded-3xl overflow-hidden shadow-2xl"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            {/* Animated Background Elements */}
            <div className={`absolute top-0 right-0 w-80 h-80 bg-gradient-to-br from-[#3d6b4a]/30 to-transparent rounded-full blur-3xl transition-transform duration-700 ${isHovered ? 'scale-110' : 'scale-100'}`}></div>
            <div className={`absolute bottom-0 left-0 w-64 h-64 bg-gradient-to-tr from-[#2c4a6e]/30 to-transparent rounded-full blur-3xl transition-transform duration-700 ${isHovered ? 'scale-110' : 'scale-100'}`}></div>
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-[#c9a86c]/10 rounded-full blur-3xl"></div>
            
            {/* Decorative Lines */}
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#c9a86c]/50 to-transparent"></div>
            <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#c9a86c]/50 to-transparent"></div>

            <div className="relative px-8 py-14 md:px-16 md:py-16">
              <div className="flex flex-col lg:flex-row items-center gap-10">
                {/* Left Content */}
                <div className="flex-1 text-center lg:text-left">
                  {/* Badge */}
                  <div className="inline-flex items-center gap-2 bg-[#c9a86c]/20 border border-[#c9a86c]/30 px-4 py-2 rounded-full mb-6">
                    <span className="relative flex h-2 w-2">
                      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#c9a86c] opacity-75"></span>
                      <span className="relative inline-flex rounded-full h-2 w-2 bg-[#c9a86c]"></span>
                    </span>
                    <span className="text-xs font-bold text-[#c9a86c] tracking-wider">30秒で完了</span>
                  </div>

                  <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 leading-tight" style={{ fontFamily: 'Noto Serif JP, serif' }}>
                    比較表を見ても<br className="md:hidden" />
                    <span className="text-[#c9a86c]">迷ってしまう方へ</span>
                  </h2>
                  
                  <p className="text-base text-white/70 mb-8 max-w-lg leading-relaxed">
                    3つの簡単な質問に答えるだけで、あなたの職場環境・働き方に<br className="hidden md:block" />
                    最適なモデルをAIが診断します。
                  </p>

                  {/* Features */}
                  <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 mb-8">
                    <div className="flex items-center gap-2 bg-white/5 px-4 py-2 rounded-full">
                      <i className="ri-time-line text-[#c9a86c]"></i>
                      <span className="text-xs text-white/80">所要時間30秒</span>
                    </div>
                    <div className="flex items-center gap-2 bg-white/5 px-4 py-2 rounded-full">
                      <i className="ri-questionnaire-line text-[#c9a86c]"></i>
                      <span className="text-xs text-white/80">質問はたった3つ</span>
                    </div>
                    <div className="flex items-center gap-2 bg-white/5 px-4 py-2 rounded-full">
                      <i className="ri-shield-check-line text-[#c9a86c]"></i>
                      <span className="text-xs text-white/80">登録不要</span>
                    </div>
                  </div>

                  {/* CTA Button */}
                  <button
                    onClick={goToDiagnosis}
                    className="group relative bg-gradient-to-r from-[#c9a86c] to-[#d4b87a] text-[#1a2332] px-10 py-4 rounded-full text-base font-bold hover:shadow-xl hover:shadow-[#c9a86c]/20 transition-all duration-300 inline-flex items-center gap-3 whitespace-nowrap cursor-pointer overflow-hidden"
                  >
                    <span className="absolute inset-0 bg-white/20 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-500"></span>
                    <i className="ri-stethoscope-line text-xl relative"></i>
                    <span className="relative">無料でモデル診断を受ける</span>
                    <i className="ri-arrow-right-line text-xl relative group-hover:translate-x-1 transition-transform"></i>
                  </button>
                </div>

                {/* Right Visual */}
                <div className="flex-shrink-0 hidden lg:block">
                  <div className="relative">
                    {/* Main Circle */}
                    <div className="w-64 h-64 rounded-full bg-gradient-to-br from-white/10 to-white/5 border border-white/10 flex items-center justify-center">
                      <div className="w-48 h-48 rounded-full bg-gradient-to-br from-white/10 to-transparent border border-white/10 flex items-center justify-center">
                        <div className="w-32 h-32 rounded-full bg-gradient-to-br from-[#c9a86c]/20 to-[#c9a86c]/5 border border-[#c9a86c]/30 flex items-center justify-center">
                          <i className="ri-stethoscope-line text-5xl text-[#c9a86c]"></i>
                        </div>
                      </div>
                    </div>

                    {/* Floating Elements */}
                    <div className="absolute -top-4 -right-4 w-20 h-20 rounded-2xl bg-[#3d6b4a] flex items-center justify-center shadow-lg animate-bounce" style={{ animationDuration: '3s' }}>
                      <div className="text-center">
                        <div className="text-lg font-bold text-white">Core</div>
                        <div className="text-[10px] text-white/60">標準</div>
                      </div>
                    </div>
                    <div className="absolute top-1/2 -right-8 -translate-y-1/2 w-20 h-20 rounded-2xl bg-[#2c4a6e] flex items-center justify-center shadow-lg animate-bounce" style={{ animationDuration: '3.5s', animationDelay: '0.5s' }}>
                      <div className="text-center">
                        <div className="text-lg font-bold text-white">Pro</div>
                        <div className="text-[10px] text-white/60">高機能</div>
                      </div>
                    </div>
                    <div className="absolute -bottom-4 right-8 w-20 h-20 rounded-2xl bg-[#c9a86c] flex items-center justify-center shadow-lg animate-bounce" style={{ animationDuration: '4s', animationDelay: '1s' }}>
                      <div className="text-center">
                        <div className="text-lg font-bold text-[#1a2332]">Style</div>
                        <div className="text-[10px] text-[#1a2332]/60">健康</div>
                      </div>
                    </div>

                    {/* Connection Lines */}
                    <svg className="absolute inset-0 w-full h-full pointer-events-none" viewBox="0 0 256 256">
                      <path d="M128 128 L220 40" stroke="rgba(201,168,108,0.3)" strokeWidth="1" strokeDasharray="4 4" fill="none" />
                      <path d="M128 128 L240 128" stroke="rgba(201,168,108,0.3)" strokeWidth="1" strokeDasharray="4 4" fill="none" />
                      <path d="M128 128 L200 220" stroke="rgba(201,168,108,0.3)" strokeWidth="1" strokeDasharray="4 4" fill="none" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* B2B Offer Section */}
      <section className="py-16 bg-white">
        <div className="max-w-5xl mx-auto px-6">
          <div className="bg-[#1a1a2e] rounded-3xl p-8 md:p-12 text-white text-center relative overflow-hidden">
            {/* Background Decoration */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-amber-400/10 rounded-full blur-3xl"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-[#8E7CC3]/10 rounded-full blur-3xl"></div>
            
            <div className="relative">
              {/* Special Price Badge */}
              <div className="inline-flex items-center gap-2 bg-gradient-to-r from-amber-400 to-amber-500 text-[#1a1a2e] px-6 py-2 rounded-full text-sm font-bold mb-6">
                <i className="ri-vip-crown-2-line text-lg"></i>
                <span>法人様限定 特別価格適用</span>
              </div>
              
              <h2 className="text-3xl md:text-4xl font-bold mb-4">法人様限定の特別サポート</h2>
              <p className="text-base md:text-lg text-white/80 mb-8">
                導入台数に応じた<span className="text-amber-400 font-bold">ボリュームディスカウント</span>をご用意<br />
                まずはお気軽にお見積もりをご依頼ください
              </p>
              
              {/* Benefits List */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-10">
                <div className="flex flex-col items-center">
                  <div className="w-16 h-16 bg-amber-400/20 rounded-full flex items-center justify-center mb-3">
                    <i className="ri-percent-line text-3xl text-amber-400"></i>
                  </div>
                  <div className="text-sm font-medium">特別価格適用</div>
                  <div className="text-xs text-white/60 mt-1">台数に応じて割引</div>
                </div>
                <div className="flex flex-col items-center md:border-l border-white/20">
                  <div className="w-16 h-16 bg-[#8E7CC3]/20 rounded-full flex items-center justify-center mb-3">
                    <i className="ri-file-list-3-line text-3xl text-[#B8A9D9]"></i>
                  </div>
                  <div className="text-sm font-medium">無料見積もり</div>
                  <div className="text-xs text-white/60 mt-1">最短即日対応</div>
                </div>
                <div className="flex flex-col items-center md:border-l border-white/20">
                  <div className="w-16 h-16 bg-[#8E7CC3]/20 rounded-full flex items-center justify-center mb-3">
                    <i className="ri-truck-line text-3xl text-[#B8A9D9]"></i>
                  </div>
                  <div className="text-sm font-medium">一括配送対応</div>
                  <div className="text-xs text-white/60 mt-1">全国対応可能</div>
                </div>
                <div className="flex flex-col items-center md:border-l border-white/20">
                  <div className="w-16 h-16 bg-[#8E7CC3]/20 rounded-full flex items-center justify-center mb-3">
                    <i className="ri-tools-line text-3xl text-[#B8A9D9]"></i>
                  </div>
                  <div className="text-sm font-medium">設置サポート</div>
                  <div className="text-xs text-white/60 mt-1">オプション対応</div>
                </div>
              </div>

              {/* CTA Button */}
              <div className="relative inline-block">
                <button
                  onClick={scrollToContact}
                  className="bg-gradient-to-r from-amber-400 to-amber-500 text-[#1a1a2e] px-8 md:px-12 py-4 md:py-5 rounded-full text-base md:text-lg font-bold hover:from-amber-300 hover:to-amber-400 transition-all flex items-center space-x-3 shadow-xl whitespace-nowrap cursor-pointer mx-auto"
                >
                  <i className="ri-building-2-line text-xl"></i>
                  <span>法人特別価格でお見積もり</span>
                  <i className="ri-arrow-right-line text-xl"></i>
                </button>
                <div className="mt-3 text-xs text-white/60">
                  <i className="ri-time-line mr-1"></i>
                  30秒で完了・最短即日回答
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
